// Default import is reliable for CJS modules: Rollup maps module.exports → the default export.
import _rules from '@rules';

export const {
  validateDeck,
  calculateDeckStats,
  getCardTypes,
  cardHasType,
  getCardDomains,
  getLegendTags,
  cardHasChampionTag,
  cardCost,
  isInDomainIdentity,
  DOMAINS,
} = _rules;
